import React, { useContext } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import * as ROUTES from './constants/routes';

import Landing from "./pages/Landing";
import Splash from "./pages/Splash";
import Path from "./pages/Path";
import Chatbot from "./pages/Chatbot";
import Dashboard from "./pages/Dashboard";
import DashboardStudent from "./components/DashboardStudent";
import DashboardOtherStudent from "./components/DashboardOtherStudent";
import Gallery from './pages/Gallery';
import StoreProvider, { StoreContext } from "./containers/Store";
import Auth from "./containers/Auth";
import Layout from "./components/Layout";
import Logout from './components/Logout';


import "./App.css";

const App = () => {
  return (
    <StoreProvider>
      <StoreContext.Consumer>
        {({
            tracking: { 
              path: pat,
              activityId: actId,
            },
          }) => {
          let { path } = pat;
          if (!path) path = 0;
          let { activityId } = actId;
          if (!activityId) activityId = 0;

          return (
            <Router>
              <Auth>
                <Layout>
                  <Route exact path={ROUTES.SPLASH} render={() => <Splash />} />
                  <Route path={ROUTES.LANDING} render={() => <Landing />} />
                  <Route path={ROUTES.PATH} render={() => <Path path={path} activityId={activityId}/>} />
                  <Route path={ROUTES.CHATBOT} render={() => <Chatbot />} />
                  <Route path={ROUTES.DASHBOARD} render={() => <Dashboard />} />
                  <Route path={ROUTES.LOGOUT} render={() => <Logout />} />
                  <Route path={ROUTES.STUDENT} render={() => <DashboardStudent />} />
                  <Route path={ROUTES.OTHERSTUDENT} render={() => <DashboardOtherStudent />} />
                  <Route path={ROUTES.GALLERY} render={() => <Gallery />} />
                  {/* <Route path={ROUTES.ADMIN} render={() => <Admin />} /> */}
                  {/* <Route path={ROUTES.SIGN_UP} render={() => <SignUp/>} /> */}
                  {/* <Route path={ROUTES.SIGN_IN} render={() => <SignIn/>} /> */}
                  {/* <Route path={ROUTES.PASSWORD_FORGET} render={() => <PasswordForget/>} /> */}
                </Layout>
              </Auth>
            </Router>
          )
        }}
      </StoreContext.Consumer>
    </StoreProvider>
  );
};

export default App;
